import { formatDistanceToNow, parseJSON } from "date-fns";

export const formatRowCount = (rows: number): string =>
  `${new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(rows)} rows`;

export const formatRelativeTime = (iso: string): string => {
  const date = parseJSON(iso);
  if (isNaN(date.getTime())) {
    return "";
  }
  return formatDistanceToNow(date, { addSuffix: true });
};
